import {
  createReactRouterV6DataOptions,
  getWebInstrumentations,
  initializeFaro,
  ReactIntegration,
} from '@grafana/faro-react';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import { matchRoutes } from 'react-router-dom';

let faroInitialized = false;

export const initFaro = (environment: string, version: string) => {
  if (faroInitialized) {
    return;
  }

  faroInitialized = true;

  try {
    initializeFaro({
      url: 'https://faro-collector-prod-us-central-0.grafana.net/collect/2a817d8d71a61b6c39d97c719677a7df',
      app: {
        name: 'Asset Transfer UI',
        version,
        environment,
      },
      sessionTracking: {
        samplingRate: 0.5,
      },
      instrumentations: [
        ...getWebInstrumentations(),
        new TracingInstrumentation(),
        new ReactIntegration({
          router: createReactRouterV6DataOptions({
            matchRoutes,
          }),
        }),
      ],
    });
  } catch (error) {
    console.error('Failed to initialize Faro:', error);
  }
};
